import React, { Children } from 'react';
import { motion } from 'framer-motion';
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 25
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function TestimonialsSection() {
  return <section className="w-full bg-brand-card py-20 md:py-28 px-6" data-id="element-232">
      <div className="max-w-5xl mx-auto" data-id="element-233">
        <motion.p className="text-2xl md:text-3xl text-brand-dark/60 text-center mb-3" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} data-id="element-234">
          Resultados reales de personas como vos
        </motion.p>

        <motion.h2 className="text-2xl md:text-3xl font-bold text-brand-dark text-center mb-14" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-235">
          Esto dicen quienes ya están aplicando la guía 👇
        </motion.h2>

        <motion.div className="grid grid-cols-1 md:grid-cols-3 gap-6" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.2
      }} data-id="element-236">
          <motion.div variants={itemVariants} className="bg-brand-bg rounded-xl border border-white/10 p-8" data-id="element-237">
            <p className="text-brand-dark/70 leading-relaxed mb-6" data-id="element-238">
              "Por fin alguien que te explica las cosas de forma simple. Dejé de
              dar vueltas y empecé a{' '}
              <span className="text-brand-green font-semibold" data-id="element-239">avanzar</span> de
              verdad."
            </p>
            <div className="flex items-center gap-3" data-id="element-240">
              <div className="w-10 h-10 rounded-full bg-brand-green/15 flex items-center justify-center text-brand-green font-semibold text-sm" aria-hidden="true" data-id="element-241">
                M
              </div>
              <span className="text-sm font-medium text-brand-dark" data-id="element-242">
                Martina
              </span>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-brand-bg rounded-xl border border-white/10 p-8" data-id="element-243">
            <p className="text-brand-dark/70 leading-relaxed mb-6" data-id="element-244">
              "Había probado de todo y nada me funcionaba. Esta guía me dio la{' '}
              <span className="text-brand-green font-semibold" data-id="element-245">claridad</span>{' '}
              que necesitaba para elegir un camino y seguirlo."
            </p>
            <div className="flex items-center gap-3" data-id="element-246">
              <div className="w-10 h-10 rounded-full bg-brand-green/15 flex items-center justify-center text-brand-green font-semibold text-sm" aria-hidden="true" data-id="element-247">
                L
              </div>
              <span className="text-sm font-medium text-brand-dark" data-id="element-248">Lucas</span>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-brand-bg rounded-xl border border-white/10 p-8" data-id="element-249">
            <p className="text-brand-dark/70 leading-relaxed mb-6" data-id="element-250">
              "Lo mejor es que va directo al punto. Sin relleno, sin promesas
              exageradas. Justo{' '}
              <span className="text-brand-green font-semibold" data-id="element-251">
                lo que necesitaba
              </span>{' '}
              para empezar."
            </p>
            <div className="flex items-center gap-3" data-id="element-252">
              <div className="w-10 h-10 rounded-full bg-brand-green/15 flex items-center justify-center text-brand-green font-semibold text-sm" aria-hidden="true" data-id="element-253">
                S
              </div>
              <span className="text-sm font-medium text-brand-dark" data-id="element-254">Sofía</span>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}